import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const handleHomeClick = () => {
    setMobileMenuOpen(false);
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container nav-container">
        <Link to="/" className="logo">
          <img src="/logo.png" alt="CAEI Logo" className="logo-image" />
          <div className="logo-text">
            <h1 className="logo-title">CAEI</h1>
            <p className="logo-subtitle">Community Awareness & Empowerment Initiative</p>
          </div>
        </Link>
        <button 
          className={`mobile-menu-btn ${mobileMenuOpen ? 'open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <li><Link to="/" onClick={handleHomeClick}>Home</Link></li>
          <li><Link to="/about" onClick={() => setMobileMenuOpen(false)}>About Us</Link></li>
          <li><Link to="/services" onClick={() => setMobileMenuOpen(false)}>Services</Link></li>
          <li><Link to="/impact" onClick={() => setMobileMenuOpen(false)}>Impact</Link></li>
          <li><Link to="/objectives" onClick={() => setMobileMenuOpen(false)}>Objectives</Link></li>
          <li><Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="nav-contact-btn">Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
